import { resolve } from '../../init/store';
import states from './states';

export default () =>
    resolve.currentCompany.companyType === 'RESELLER'
        ? [...states]
        : states.filter(name => !name.startsWith('company.reseller'));



// WEBPACK FOOTER //
// ./src/portal/components/sp-global-search/searchable-states.js